<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <Bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">

      <locale />

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.Name }} {{ userData.Family }}
            </p>
            <span class="user-status">{{ userData.UserRoleTitle }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="userData.Image"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
<!--        <b-dropdown-item-->
<!--          link-class="d-flex align-items-center"-->
<!--          @click="siteInfo()"-->
<!--        >-->
<!--          <feather-icon-->
<!--            size="16"-->
<!--            icon="SettingsIcon"-->
<!--            class="mr-50"-->
<!--          />-->
<!--          <span>تنظیمات</span>-->
<!--        </b-dropdown-item>-->
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout()"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
            @click="logout()"
          />
          <span
            @click="logout()"
          >خروج
          </span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-modal
        v-model="showSiteInfo"
        v-if="showSiteInfo"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تنظیمات"
        :no-close-on-backdrop="true"
        size="lg"
        @ok="save"
    >
      <b-row>

      <b-col md="12">
        <b-form-group
            label="عنوان"
            label-for="Title"
        >
          <b-form-input
              v-model="row.Title"
              id="Title"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="عنوان"
            label-for="Title"
        >
          <b-form-input
              v-model="row.Title"
              id="Title"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="عنوان"
            label-for="Title"
        >
          <b-form-input
              v-model="row.Title"
              id="Title"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="آدرس"
            label-for="Address"
        >
          <b-form-input
              v-model="row.Address"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

        <b-col cols="12" class="mt-1"><h6 class="section-label mx-1 mb-2">ارتباط با ما</h6></b-col>


      <b-col md="6">
        <b-form-group
            label="آدرس"
            label-for="Address"
        >
          <b-form-input
              v-model="row.Address"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
            label="ایمیل"
            label-for="Email"
        >
          <b-form-input
              v-model="row.Email"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
            label="تماس"
            label-for="Phone"
        >
          <b-form-input
              v-model="row.Phone"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
        <b-col>
        <b-form-group
            label="توضیحات"
            label-for="Description"
        >
          <b-form-textarea
              v-model="row.Description"
              rows="5"
              no-resize
          />
        </b-form-group>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BAvatar,
} from 'bootstrap-vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Bookmarks from '@core/layouts/components/app-navbar/components/Bookmarks'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BAvatar,
    // Navbar Components
    DarkToggler,
    Bookmarks,
    Locale,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      showSiteInfo: false,
      row: {}
    }
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'login' })
    },
    siteInfo(){
      this.showSiteInfo = true
      // this.loading = true
      // this.$http.post(
      //     this.$api.productcategory.get, {
      //       Id: this.Form.Id,
      //     },
      // )
      //     .then(res => {
      //       this.loading = false
      //       this.Form = res.data
      //     })
    },
    save(){

    }
  },
}
</script>
